import React from 'react';
import { motion } from 'framer-motion';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 }
};

const sectors = [
  { icon: '/assets/icon-sector-manufacturing.png', label: 'Manufacturing' },
  { icon: '/assets/icon-sector-engineering.png', label: 'Engineering' },
  { icon: '/assets/icon-sector-construction.png', label: 'Construction' },
  { icon: '/assets/icon-sector-energy.png', label: 'Energy' },
  { icon: '/assets/icon-sector-transport.png', label: 'Transport' },
  { icon: '/assets/icon-sector-tech.png', label: 'Tech' },
];

const SectorsSection = () => {
  return (
    <section id="sectors" className="py-20 md:py-28 bg-white overflow-hidden" data-testid="sectors-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div {...fadeInUp}>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-carbon mb-6 tracking-tight">
              BUILT FOR OPERATIONAL WORKPLACES
            </h2>
            <p className="text-base text-carbon/80 leading-relaxed mb-10">
              Kalobrate is designed for workplaces where shift patterns, safety, production pressures,
              dispersed teams and a divide between office and operational roles can make culture
              harder to understand and change.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {sectors.map((sector, i) => (
                <motion.div
                  key={sector.label}
                  className="bg-gray-50 border border-gray-100 px-5 py-4 flex items-center gap-3"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                >
                  <img src={sector.icon} alt="" className="w-6 h-6 flex-shrink-0" />
                  <span className="text-sm font-medium text-carbon">{sector.label}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            className="relative"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <img
              src="https://images.unsplash.com/photo-1581091212991-8891c7d4bd9b?auto=format&fit=crop&w=800&q=80"
              alt="Engineers collaborating in a manufacturing facility"
              className="w-full h-[400px] lg:h-[500px] object-cover corner-cut-br"
            />
            <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-golden -z-10" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SectorsSection;
